import { EOffersFromHistoryActionTypes } from '../../actions/offersFromHistory/types';
import { IRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { TReduxActions } from '../../types/redux';

export interface IRecentlyViewedOfferState {
  recentlyViewed: IRecentlyViewedOffer[];
}

export const initialState = {
  recentlyViewed: [],
};

export const recentlyViewedReducer = (
  state: IRecentlyViewedOfferState = initialState,
  action: TReduxActions,
): IRecentlyViewedOfferState => {
  switch (action.type) {
    case EOffersFromHistoryActionTypes.Set:
      return {
        ...state,
        recentlyViewed: action.payload.recentlyViewed,
      };

    default:
      return state;
  }
};
